export default "__VITE_ASSET__CU0zRSKa__"